export const template = `
<gh-table-page ref="table" 
:args-query="argsQuery" 
:module="module" 
:cls="cls" 
:tabs="tabs" 
showTabs="true" 
:templateModel="templateModel">
<template #area_query>
  <v-layout row align-center>
    <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
      append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
    </v-text-field>
  </v-layout>
</template>
</gh-table-page>
`


export const js = `function generate() {
  return {
    name: 'customCode',
    data() {
        return {
            tabs: [
                {
                    title: "数据维护",
                    show: true
                },
                {
                    title: "详细信息"
                }
            ],
            argsQuery: {
                keyword: ""
            },
            module: "{module}", // 模块
            cls: "{cls}", // 类
            serviceMethods: {
                query: null
            },
            templateModel: {}
        }
    }
  };
}`

export const css = `.wrapper {
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
}
`